import React from "react";
import "../styles/matchlistcard.css";

export default function MatchListCard({
  homeTeam,
  awayTeam,
  homeLogo,
  awayLogo,
  leagueLogo,
  league,
  date,
  onClick
}) {
  return (
    <div className="mlc-row-wrapper" onClick={onClick}>

      {/* BAL – LIGA LOGÓ KIS KOCKA */}
      <div className="mlc-league-box">
        <img src={`/images/leagues/${leagueLogo}`} alt={league} />
      </div>

      {/* JOBB – FŐ MECCS KÁRTYA */}
      <div className="mlc-card">

        {/* KÖZÉP – CSAPATOK SZIMMETRIKUSAN */}
        <div className="mlc-teams-center">

          {/* HAZAI */}
          <div className="mlc-team">
            <img src={`/images/teams/${homeLogo}`} alt={homeTeam} />
            <span>{homeTeam}</span>
          </div>

          {/* VS + DÁTUM */}
          <div className="mlc-mid">
            <div className="vs">VS</div>
            <div className="mlc-date">{date}</div>
          </div>

          {/* VENDÉG */}
          <div className="mlc-team">
            <img src={`/images/teams/${awayLogo}`} alt={awayTeam} />
            <span>{awayTeam}</span>
          </div>

        </div>

        {/* JOBB ALSÓ – FINOM LIGA SZÖVEG */}
        <div className="mlc-league-name">
          {league}
        </div>

        {/* NYÍL */}
        <div className="mlc-arrow"><i class="bi bi-arrow-right"></i></div>

      </div>
    </div>
  );
}